import React from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab } from 'react-bootstrap'

export const TabsUnstyled = props => (
  <Tabs className={props.className} id={props.id}>
    {props.tabs.map((tab, index) => (
      <Tab eventKey={index} key={`tab-${index}`} title={tab.tabTitle}>
        {tab.tabContent}
      </Tab>
    ))}
  </Tabs>
)

TabsUnstyled.propTypes = {
  className: PropTypes.string.isRequired,
  defaultActiveKey: PropTypes.number,
  id: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      tabContent: PropTypes.any.isRequired,
      tabTitle: PropTypes.string.isRequired,
    }),
  ),
}



// WEBPACK FOOTER //
// ./src/Components/Tabs/unstyled.js